import { render, staticRenderFns } from "./consentStatusCheckoutCart.vue?vue&type=template&id=6389977b&scoped=true"
import script from "./consentStatusCheckoutCart.vue?vue&type=script&lang=js"
export * from "./consentStatusCheckoutCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389977b",
  null
  
)

export default component.exports